import React, { Suspense, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Footer from "./components/views/footer";
import LoginViewModel from "./viewmodels/auth/loginViewModel";
import SignUpViewModel from "./viewmodels/auth/signupViewModel";
import MainViewModel from "./viewmodels/main/mainViewModel";
import { ToastContainer } from "react-toastify";

const LoginView = React.lazy(() => import("./components/views/auth/loginView"));
const VerifyLink = React.lazy(() => import("./components/views/verifyLink"));
const Finish = React.lazy(() => import("./components/views/finish"));
const Loader = React.lazy(() => import("./components/views/loader"));
const StartOnboarding = React.lazy(
  () => import("./components/views/onboard/startOnboarding")
);
const CreateCommunity = React.lazy(
  () => import("./components/views/onboard/createCommunity")
);
const WhoWeAre = React.lazy(
  () => import("./components/views/onboard/whoWeAre")
);
const Invite = React.lazy(() => import("./components/views/onboard/invite"));
const Navbar = React.lazy(() => import("./components/views/navbar/navbar"));

const mainViewModel = new MainViewModel(document);
const signupViewModel = new SignUpViewModel();
const loginViewModel = new LoginViewModel(document);

function App() {
  const searchParams = new URLSearchParams(document.location.search);

  useEffect(() => {
    if (searchParams.get("token")) {
      localStorage.setItem("@JWTTokenType", "Bearer");
      localStorage.setItem("@JWTToken", searchParams.get("token")!);
      loginViewModel.queryParamLogin();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div className="mainBody">
        <Suspense>
          <Routes>
            <Route
              path="/"
              element={
                <div className="grid place-content-center mt-5">
                  <div className="mt-2 lg:px-32 py-3 boxShadow">
                    <LoginView
                      mainViewModel={mainViewModel}
                      loginViewModel={loginViewModel}
                    />
                  </div>
                  <div className="flex justify-center my-2">
                    <Footer />
                  </div>
                </div>
              }
            />

            <Route
              path="/signup"
              element={
                <div className="grid place-content-center mt-5">
                  <div className="mt-2 lg:px-32 py-3 boxShadow">
                    <LoginView
                      mainViewModel={mainViewModel}
                      loginViewModel={loginViewModel}
                    />
                  </div>
                  <div className="flex justify-center my-2">
                    <Footer />
                  </div>
                </div>
              }
            />
            <Route
              path="/login"
              element={
                <div className="grid place-content-center mt-5">
                  <div className="mt-2 lg:px-32 py-3 boxShadow">
                    <LoginView
                      mainViewModel={mainViewModel}
                      loginViewModel={loginViewModel}
                    />
                  </div>
                  <div className="flex justify-center my-2">
                    <Footer />
                  </div>
                </div>
              }
            />
            {/* <Route
              path="/verify"
              element={
                <div className="grid grid-cols-1">
                  <div className="">
                    <VerifyLink
                      signupViewModel={signupViewModel}
                      mainViewModel={mainViewModel}
                    />
                  </div>
                </div>
              }
            /> */}
            <Route
              path="/start"
              element={
                <div className="grid grid-cols-2">
                  <div className="col-span-2">
                    <StartOnboarding
                      loginViewModel={loginViewModel}
                      mainViewModel={mainViewModel}
                    />
                  </div>
                </div>
              }
            />
            <Route
              path="/create"
              element={
                <div className="grid grid-cols-1 lg:grid-cols-6 mt-7 lg:mt-0">
                  <div className="col-span-1">
                    <Navbar />
                  </div>
                  <div className="col-span-5">
                    <CreateCommunity mainViewModel={mainViewModel} />
                  </div>
                </div>
              }
            />
            <Route
              path="/description"
              element={
                <div className="grid grid-cols-1 lg:grid-cols-6 mt-7 lg:mt-0">
                  <div className="col-span-1">
                    <Navbar />
                  </div>
                  <div className="col-span-5">
                    <WhoWeAre mainViewModel={mainViewModel} />
                  </div>
                </div>
              }
            />
            <Route
              path="/invite"
              element={
                <div className="grid grid-cols-1 lg:grid-cols-6 mt-7 lg:mt-0">
                  <div className="col-span-1">
                    <Navbar />
                  </div>
                  <div className="col-span-5">
                    <Invite mainViewModel={mainViewModel} />
                  </div>
                </div>
              }
            />
            <Route
              path="/finish"
              element={
                <div className="grid grid-cols-1 lg:grid-cols-6 mt-7 lg:mt-0">
                  <div className="col-span-1">
                    <Navbar />
                  </div>
                  <div className="col-span-5">
                    <Finish mainViewModel={mainViewModel} />
                  </div>
                </div>
              }
            />
            {/* <Route
              path="/load"
              element={
                <div className="">
                  <Loader mainViewModel={mainViewModel} />
                </div>
              }
            /> */}
          </Routes>
        </Suspense>
      </div>
      <ToastContainer />
    </div>
  );
}

export default App;
